import { IRelatorioAM } from "@/interfaces/IRelatorioAM";
import { createAction } from "@reduxjs/toolkit";

const add = createAction("RELATORIO_AM/add", (item: IRelatorioAM) => ({
  payload: { item },
}));

const remove = createAction("RELATORIO_AM/remove", (offlineId: number) => ({
  payload: { offlineId },
}));

const update = createAction("RELATORIO_AM/update", (item: IRelatorioAM) => ({
  payload: { item },
}));

export const relatorioAMAction = {
  add,
  remove,
  update,
};
